import React from "react";
import CourseChatPanel from "components/chat/CourseChatPanel";
import { useCourse } from "../../context/CourseContext";

export default function InstructorChatPage() {
  const { course } = useCourse();

  return (
    <div className="flex min-h-0 flex-col">
      <CourseChatPanel courseId={course.id} scope="instructor" canMute />
    </div>
  );
}
